package one.healthium.ui.compose.theme.styles

import androidx.compose.runtime.Stable
import androidx.compose.ui.graphics.Color

@Stable
data class AppButtonStyle(
    val containerColor: Color? = null,
    val contentColor: Color? = null,
)

sealed interface AppButtonStyleRef {
    data object Default : AppButtonStyleRef
    data object Primary : AppButtonStyleRef
    data object PrimaryInverted : AppButtonStyleRef
}